import { render } from "./Corporation.vue?vue&type=template&id=103abad6&scoped=true"
import script from "./Corporation.vue?vue&type=script&lang=js"
export * from "./Corporation.vue?vue&type=script&lang=js"

import "./Corporation.vue?vue&type=style&index=0&id=103abad6&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103abad6"]])

export default __exports__